import { FaCheck } from "react-icons/fa"

export const TickIcon = FaCheck